import { getDateTime } from '../../../helpers/utils'
import translate from '../../../i18n'
import { ICorporateCreditsDistributionScheduleHistory } from '../../../pages/corporates-container/share-type'
import { PageInfo } from '../../../share-types'
import { Space, Table, Typography } from 'antd'
import { ColumnsType } from 'antd/lib/table'
import { useState } from 'react'

const { Title } = Typography

interface CorporateCreditsDistributionScheduleHistoriesTableProps {
  histories: ICorporateCreditsDistributionScheduleHistory[]
}

const defaultPage = {
  pageSize: 10,
  currentPage: 1,
  count: 0,
}

const CorporateCreditsDistributionScheduleHistoriesTable = ({
  histories,
}: CorporateCreditsDistributionScheduleHistoriesTableProps) => {
  const [pageInfo, setPageInfo] = useState<PageInfo>(defaultPage)

  const columns: ColumnsType<ICorporateCreditsDistributionScheduleHistory> = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      sorter: (a, b) => a.id - b.id,
      fixed: 'left',
      width: 60,
    },
    {
      title: translate('status'),
      dataIndex: 'status',
      key: 'status',
      fixed: 'left',
      width: 100,
    },
    {
      title: translate('corporateCreditsHistories.notes'),
      dataIndex: 'notes',
      key: 'notes',
      width: 100,
    },
    {
      title: translate('createdAt'),
      dataIndex: 'createdAt',
      key: 'createdAt',
      width: 120,
      render: (createdAt: string) => (createdAt ? getDateTime(createdAt) : ''),
    },
  ]

  return (
    <Space className="table-space" orientation="vertical" size={16}>
      <Title level={5}>{translate('navbar.corporateCreditsDistributionSchedule.histories')}</Title>

      <Table
        rowKey={record => record.id}
        columns={columns}
        dataSource={histories}
        scroll={{ x: 1140 }}
        pagination={{
          current: pageInfo?.currentPage,
          pageSize: pageInfo?.pageSize,
          total: pageInfo?.count,
          onChange: (page: number, pageSize: number) => {
            setPageInfo({
              ...pageInfo,
              currentPage: page,
              pageSize: pageSize,
            })
          },
        }}
      />
    </Space>
  )
}

export default CorporateCreditsDistributionScheduleHistoriesTable
